import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import {isSet,numericValidationWithDotWithoutNegative} from '../../Utils/CommonFunctions';

class Percentage extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler,value,max,decimal} = this.props;
    let input_value = e.target.value;
    // var validNumber = new RegExp(/^\d*\.?\d*$/);
    // if (input_value <= 100) {
      const maxLength = max;
      const maxDecimalLength = decimal;
      let pattern;
      if(maxDecimalLength === 0){
          pattern = new RegExp(`^(\\d{0,${maxLength}})?$`);
      }else{
          pattern = new RegExp(`^(\\d{0,${maxLength}})(\\.\\d{0,${maxDecimalLength}})?$`);
      }
      if (pattern.test(input_value)) { 
        changeHandler(input_value);
      } else {
        changeHandler(isSet(value,''));
      }
    // }
  } 

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);  
    

    return (
      <Wrp>
        <input 
          type="text"
          {...attr}
          onKeyPress={numericValidationWithDotWithoutNegative}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}          
           /> 
      </Wrp>        
    );
  }
}

Percentage.defaultProps = {
  isMandatory:false,
  className: 'form-control',
  max:5,
  maxLength:5,
  decimal:2
}

export default Percentage;